import { useNode, useEditor } from "@craftjs/core";
import React from "react";
import GrigoraCSSRenderer from "./../css-render";
import { NewsletterSettings } from "./settings";
import SVGIcons from "../../input/icons.json";
import icon from "./icon";
import SVG from "react-inlinesvg";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import { INPUT_LIMITS } from "../../input-limits";

export const Newsletter = (props) => {
  const {
    id,
    connectors: { connect, drag },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    actions: { selectNode },
  } = useEditor();

  const {
    placeholderText = "Subscribe Now",
    isSubmitButtonVisible = true,
    isSubmitButtonIcon = true,
    submitButtonText = "Subscribe",
    icon = "envelope-fill",
    customIcon,
    hasCustomIcon,
    message,
    isSubmitted = false,
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-newsletter": true,
      [`newsletter-${id}`]: id,
    },
    blockProps.className,
  );

  return !isSubmitted ? (
    <>
      <div
        {...blockProps}
        ref={(ref) => connect(drag(ref))}
        className={wrapperClass}
        onFocus={() => {
          selectNode(id);
        }}
        data-grigora-block="true"
        data-grigora-block-id={id}
      >
        <style>{`${getDynamicCSS(id, props)}`}</style>
        <style>{`${GrigoraCSSRenderer.blockCSS__Newsletter(id, props)}`}</style>

        <input
          placeholder={placeholderText}
          className="newsletter-input-field"
          type="text"
          minLength={INPUT_LIMITS["newsletter-text"].minlength}
          maxLength={INPUT_LIMITS["newsletter-text"].maxlength}
        />
        <div className="newsletter-icon">
          {isSubmitButtonVisible ? (
            isSubmitButtonIcon ? (
              <>
                {hasCustomIcon && customIcon !== "" ? (
                  <SVG className="svg-icon" title={icon} src={customIcon} />
                ) : (
                  <>
                    {icon && SVGIcons[icon] && (
                      <SVG
                        className="svg-icon"
                        title={icon}
                        src={SVGIcons[icon]}
                      />
                    )}
                  </>
                )}
              </>
            ) : (
              <span className="newsletter-text">{submitButtonText}</span>
            )
          ) : null}
        </div>
      </div>
    </>
  ) : (
    <p>{message}</p>
  );
};

// To Avoid Mangling in Production
Newsletter.displayName = "Newsletter";

Newsletter.craft = {
  name: "Newsletter",
  props: {},
  related: {
    settings: NewsletterSettings,
    icon: icon,
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    category: "miscellaneous",
    isHiddenInPostEditor: true,
  },
  custom: {
    name: "Newsletter",
    slug: "grigora/newsletter",
  },
};
